import React from 'react'
import './ClickItem.css'

export default function ClickItem({children, ...rest}) {

  return (
    <button className='clickItem' onClick={rest.onClick} {...rest}>{children}</button>
  )
}
